const block = [
    {
        key: 'b1',
        img: require("~images/products/2020-06-23/user friendly.png"),
        title: "USER FRIENDLY",
        description: "Core features available to customise online learning platform with little to no hassle involved."
    },

    {
        key: 'b2',
        img: require("~images/products/2020-06-23/collaborative.png"),
        title: "COLLABORATIVE ACTIVITIES",
        description: "Engage your students and immerse them in rich multimedia content to enhance their learning."
    },


    {
        key: 'b3',
        img: require("~images/products/2020-06-23/course listing.png"),
        title: "COURSE LISTING",
        description: "Build and design courses without fretting about the technical requirements."
    },

    {
        key: 'b4',
        img: require("~images/products/2020-06-23/quiz bulder.png"),
        title: "QUIZ BUILDER",
        description: "Select from a variety of question types to suit your teaching needs."
    },

    {
        key: 'b5',
        img: require("~images/products/2020-06-23/branding.png"),
        title: "CUSTOMIZATION & BRANDING",
        description: "Have full control of your brand and tailor the look and feel of your site to your liking."
    },

    {
        key: 'b6',
        img: require("~images/products/2020-06-23/report.png"),
        title: "REPORTS",
        description: "Track your student’s learning."
    },

]

export default block